import React from 'react'
import Layout from '../../component/layout/Layout'
import About from '../../sections/About'


const AboutPage = () => {
  return (
    <Layout>
   <About/>
  </Layout>
  
  )
}

export default AboutPage